<template>
  <v-form id="modal" ref="form" v-model="valid">
    <v-col v-if="modalCode == 0">
      <v-row>
        <v-text-field
          v-model="info.codigo"
          label="Código"
          :rules="[rules.required, rules.nulled, rules.empty]"
        ></v-text-field>
        <v-text-field
          v-model="info.nombre"
          label="Nombre"
          :rules="[rules.required, rules.nulled, rules.empty]"
        ></v-text-field>
      </v-row>
    </v-col>
    <v-col v-if="modalCode == 5">
      <v-row>
        <v-text-field
          v-model="info.codigo"
          label="Código"
          :rules="[rules.required, rules.nulled, rules.empty]"
        ></v-text-field>
        <v-text-field
          v-model="info.nombre"
          label="Nombre"
          :rules="[rules.required, rules.nulled, rules.empty]"
        ></v-text-field>
        <v-text-field
          v-model="info.nivel"
          min="0"
          type="number"
          label="Nivel"
          :rules="[rules.required, rules.nulled, rules.empty, rules.isNumber]"
        ></v-text-field>
      </v-row>
    </v-col>
    <v-col v-if="modalCode == 1">
      <v-row>
        <v-text-field
          v-model="info.username"
          label="Usuario"
          :rules="[rules.required, rules.nulled, rules.empty]"
        ></v-text-field>
        <v-text-field
          v-model="info.nombre"
          label="Nombre"
          :rules="[rules.required, rules.nulled, rules.empty]"
        ></v-text-field>
        <v-text-field
          v-model="info.email"
          label="Email"
          :rules="[rules.required, rules.validateEmail]"
        ></v-text-field>
        <v-select
          :items="roles"
          v-model="rol"
          label="Rol"
          item-text="name"
          bottom
          @change="changeRol()"
          :rules="[rules.required, rules.nulled]"
        >
        </v-select>
        <v-text-field
          v-if="this.info.id"
          v-model="info.password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          label="Modificar contraseña del Usuario seleccionado. Si no se redacta nada se mantendrá la actual"
          @click:append="show1 = !show1"
        ></v-text-field>
        <v-text-field
          v-if="!this.info.id"
          v-model="info.password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          label="Contraseña"
          @click:append="show1 = !show1"
          :rules="[
            rules.required,
            rules.nulled,
            rules.empty,
            rules.passLength,
            rules.passCapitalLetter,
            rules.passLowCaseLetter,
            rules.passNumber,
            rules.passSpecialCharacter
          ]"
        ></v-text-field>
        <v-checkbox
          v-model="info.habilitado"
          label="Activar para habilitar al usuario"
        ></v-checkbox>
      </v-row>
    </v-col>
    <v-col v-if="modalCode == 3">
      <v-row>
        <v-text-field
          v-model="info.descripcion"
          label="Nombre"
          :rules="[rules.required, rules.nulled, rules.empty]"
        ></v-text-field>
        <v-text-field
          v-model="info.cantidad"
          min="0"
          type="number"
          label="Cantidad"
          :rules="[rules.required, rules.nulled, rules.empty, rules.isNumber]"
        ></v-text-field>
      </v-row>
    </v-col>
    <v-col v-if="modalCode == 4">
      <v-row>
        <v-text-field
          v-model="info.descripcion"
          label="Descripción"
          :rules="[rules.required, rules.nulled, rules.empty]"
        ></v-text-field>
        <v-select
          v-model="info.tipo_incidencia"
          :items="tipoIncs"
          item-text="nombre"
          item-value="tipo_incidencia.id"
          label="Tipo"
          return-object
          single-line
          hide-selected
          @change="changeIdIncidencia()"
          :rules="[rules.required, rules.nulled]"
        ></v-select>
        <v-checkbox
          v-model="info.resuelta"
          label="Activar para marcar como resuelta"
        ></v-checkbox>
      </v-row>
    </v-col>
    <v-col v-if="modalCode == 2">
      <v-row>
        <v-col class="col-4"
          ><h1>Orden {{ info.id_erp }}</h1></v-col
        >
        <v-col></v-col><v-col></v-col><v-col></v-col>
        <v-col v-if="getActualRole() != 'ROLE_TALLER'">
          <!--<v-row> Fecha inicio: {{ parseFecha(info.fecha_pedido) }} </v-row>
          <v-row>Fecha entrega: {{ parseFecha(info.fecha_entrega) }}</v-row>-->
          <v-row>
            Fecha inicio:
            <date-picker
              v-model="pickerIni"
              type="datetime"
              value-type="format"
              confirm
              confirm-text="Fijar fecha de pedido"
              :format="'DD/MM/YYYY HH:mm:ss'"
              :locale="locale"
              placeholder="Fecha de pedido"
              @change="setPickerDate(pickerIni, pickerEnd)"
              :rules="[rules.required, rules.nulled]"
            ></date-picker>
          </v-row>
          <v-row>
            Fecha entrega:
            <date-picker
              v-model="pickerEnd"
              type="datetime"
              value-type="format"
              confirm
              confirm-text="Fijar fecha de entrega"
              :format="'DD/MM/YYYY HH:mm:ss'"
              :locale="locale"
              placeholder="Fecha de entrega"
              @change="setPickerDate(pickerIni, pickerEnd)"
              :rules="[rules.required, rules.nulled]"
            ></date-picker>
          </v-row>
        </v-col>
      </v-row>
      <h4>Código de cliente: {{ this.info.id_cliente }}</h4>
      <v-row>
        <v-col class="tableFlex">
          <!-- Snackbar Resultados -->
          <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}

            <template v-slot:action="{ attrs }">
              <v-btn v-bind="attrs" text @click="snack = false"> cerrar </v-btn>
            </template>
          </v-snackbar>
          <v-select
            v-if="getActualRole() == 'ROLE_TALLER'"
            v-model="info.estado"
            :items="states"
            item-text="nombre"
            item-value="id"
            label="Estado"
            return-object
            single-line
            hide-selected
            @change="changeIdEstado()"
          ></v-select>
          <v-btn
            style="margin-bottom: 0.5em;"
            class="white--text"
            color="#004283"
            width="fit-content"
            @click="saveState(info)"
            v-if="getActualRole() == 'ROLE_TALLER'"
            >Cambiar estado del pedido</v-btn
          >
          <v-divider v-if="getActualRole() == 'ROLE_TALLER'"></v-divider>
          <v-card v-if="getActualRole() != 'ROLE_TALLER'">
            <h5>Detalles</h5>
            <v-text-field
              disabled
              v-model="info.cliente.nombre1"
              label="Cliente"
            ></v-text-field>
            <v-select
              v-model="info.Prioridad"
              :items="prioridades"
              label="Prioridad"
              item-text="nombre"
              item-value="id"
              return-object
              single-line
              hide-selected
              @change="changeIdPrioridad()"
            ></v-select>
            <v-select
              v-model="info.usuario"
              :items="users"
              item-text="username"
              item-value="id"
              label="Asignación"
              return-object
              single-line
              clearable
              hide-selected
              @change="changeIdAsignacion()"
            ></v-select>
            <v-select
              v-model="info.estado"
              :items="states"
              item-text="nombre"
              item-value="id"
              label="Estado"
              return-object
              single-line
              hide-selected
              @change="changeIdEstado()"
            ></v-select>
            <v-text-field
              v-model="info.plano_asociado"
              label="Plano asociado"
            ></v-text-field>
          </v-card>
          <v-flex v-if="this.info.id">
            <h5>Tareas</h5>
            <my-table-old
              :key="getPedidoId()"
              :pedidoId="getPedidoId()"
              :fields="this.fields"
              :modalCode="3"
              title=""
              :url="getTareasByOrder()"
              element="Tarea"
            >
            </my-table-old>
          </v-flex>
        </v-col>
        <v-col class="tableFlex">
          <v-select
            v-if="getActualRole() == 'ROLE_TALLER'"
            v-model="info.usuario"
            :items="users"
            item-text="username"
            item-value="id"
            label="Asignación"
            return-object
            single-line
            clearable
            hide-selected
            @change="saveAssignment()"
          ></v-select>
          <!-- <v-btn style="margin-bottom: 0.5em;" class="white--text" color="#004283" width="fit-content" @click="saveAssignment(info)" v-if="getActualRole() == 'ROLE_TALLER'">Cambiar asignación del pedido</v-btn> -->
          <v-btn
            style="margin-bottom: 0.5em; margin-left: 0.3em;"
            class="white--text"
            color="#004283"
            width="fit-content"
            @click="autoAssign()"
            v-if="getActualRole() == 'ROLE_TALLER'"
            >Autoasignarse pedido</v-btn
          >
          <v-divider v-if="getActualRole() == 'ROLE_TALLER'"></v-divider>
          <v-card id="areas" v-if="getActualRole() != 'ROLE_TALLER'">
            <v-textarea
              v-model="info.material_detalle"
              label="Material utilizado y detalle de los trabajos realizados"
            ></v-textarea>
            <v-textarea v-model="info.notas" label="Notas"></v-textarea><br />
          </v-card>
          <v-flex v-if="this.info.id">
            <h5>Incidencias</h5>
            <!--:key="getPedidoId()" permite que las tablas se actualicen al variar el item (orden_trabajo) a editar -->
            <my-table-old
              :key="getPedidoId()"
              :pedidoId="getPedidoId()"
              :fields="this.fields2"
              :modalCode="4"
              title=""
              :url="getIncidenciasByOrder()"
              element="Incidencia"
            >
            </my-table-old>
          </v-flex>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="modalCode == 6">
      <v-row>
        <v-col class="col-4"
          ><h1>Orden {{ info.id_erp }}</h1></v-col
        >
        <v-col></v-col><v-col></v-col><v-col></v-col>
        <v-col v-if="getActualRole() != 'ROLE_TALLER'">
          <!--<v-row> Fecha inicio: {{ parseFecha(info.fecha_pedido) }} </v-row>
          <v-row>Fecha entrega: {{ parseFecha(info.fecha_entrega) }}</v-row>-->
          <v-row>
            Fecha del pedido:
            <date-picker
              v-model="pickerIni"
              type="datetime"
              value-type="format"
              confirm
              confirm-text="Fijar fecha de pedido"
              :format="'DD/MM/YYYY HH:mm:ss'"
              :locale="locale"
              placeholder="Fecha de pedido"
              @change="setPickerDate(pickerIni, pickerEnd)"
              :rules="[rules.required, rules.nulled]"
            ></date-picker>
          </v-row>
          <v-row>
            Fecha de la entrega:
            <date-picker
              v-model="pickerEnd"
              type="datetime"
              value-type="format"
              confirm
              confirm-text="Fijar fecha de entrega"
              :format="'DD/MM/YYYY HH:mm:ss'"
              :locale="locale"
              placeholder="Fecha de entrega"
              @change="setPickerDate(pickerIni, pickerEnd)"
              :rules="[rules.required, rules.nulled]"
            ></date-picker>
          </v-row>
        </v-col>
      </v-row>
      <h4>Código de cliente: {{ this.info.id_cliente }}</h4>
      <v-row>
        <v-col class="tableFlex">
          <v-card v-if="getActualRole() != 'ROLE_TALLER'">
            <h5>Detalles</h5>
            <v-text-field
              disabled
              v-model="info.cliente.nombre1"
              label="Cliente"
            ></v-text-field>
            <v-text-field
              disabled
              v-model="info.Prioridad.nombre"
              label="Prioridad"
            ></v-text-field>
            <v-text-field
              disabled
              v-if="info.usuario != undefined"
              v-model="info.usuario.username"
              label="Asignación"
            ></v-text-field>
            <v-text-field
              disabled
              v-model="info.estado.nombre"
              label="Estado"
            ></v-text-field>
            <v-text-field
              disabled
              v-model="info.plano_asociado"
              label="Plano asociado"
            ></v-text-field>

            <v-text-field
              disabled
              v-if="info.usuario == undefined"
              label="Sin asignación"
            ></v-text-field>
          </v-card>
          <v-flex v-if="this.info.id">
            <h5>Tareas</h5>
            <my-table-old
              :key="getPedidoId()"
              :pedidoId="getPedidoId()"
              :fields="this.fieldsCap"
              :modalCode="3"
              title=""
              :url="getTareasByOrder()"
              element="Tarea"
            >
            </my-table-old>
          </v-flex>
        </v-col>
        <v-col class="tableFlex">
          <v-card id="areas" v-if="getActualRole() != 'ROLE_TALLER'">
            <v-textarea
              disabled
              v-model="info.material_detalle"
              label="Material utilizado y detalle de los trabajos realizados"
            ></v-textarea>
            <v-textarea v-model="info.notas" disabled label="Notas"></v-textarea
            ><br />
          </v-card>
          <v-flex v-if="this.info.id">
            <h5>Incidencias</h5>
            <!--:key="getPedidoId()" permite que las tablas se actualicen al variar el item (orden_trabajo) a editar -->
            <my-table-old
              :key="getPedidoId()"
              :pedidoId="getPedidoId()"
              :fields="this.fields2Cap"
              :modalCode="4"
              title=""
              :url="getIncidenciasByOrder()"
              element="Incidencia"
            >
            </my-table-old>
          </v-flex>
        </v-col>
      </v-row>
    </v-col>
  </v-form>
</template>
<script>
import axios from "axios";
import apiConfig from "../../../services/api.config";
export default {
  props: {
    modalCode: Number,
    info: Object,
    actualRol: String
  },
  async created() {
    // console.log("ID",this.$store.state.auth.user.id)
    await this.initModalCode();
  },
  data() {
    return {
      snack: false,
      snackColor: "",
      snackText: "",
      show1: false,
      prioridades: [],
      users: [],
      states: [],
      tipoIncs: [],
      rol: null,
      pickerIni: new Date(),
      pickerEnd: new Date(),
      roles: [],
      fields: [
        {
          text: "Código",
          sortable: true,
          value: "id",
          align: "center"
        },
        {
          text: "Nombre",
          sortable: true,
          value: "descripcion",
          align: "center"
        },
        {
          text: "Cantidad",
          sortable: true,
          value: "cantidad",
          align: "center"
        },
        {
          text: "Acciones",
          sortable: false,
          value: "actions",
          align: "center"
        }
      ],
      fields2: [
        {
          text: "Resuelta",
          sortable: true,
          value: "resuelta",
          align: "center"
        },
        {
          text: "Código",
          sortable: true,
          value: "id",
          align: "center"
        },
        {
          text: "Descripción",
          sortable: true,
          value: "descripcion",
          align: "center"
        },
        {
          text: "Tipo",
          sortable: true,
          value: "tipo_incidencia.codigo",
          align: "center"
        },
        {
          text: "Acciones",
          sortable: false,
          value: "actions",
          align: "center"
        }
      ],
      fieldsCap: [
        {
          text: "Código",
          sortable: true,
          value: "id",
          align: "center"
        },
        {
          text: "Nombre",
          sortable: true,
          value: "descripcion",
          align: "center"
        },
        {
          text: "Cantidad",
          sortable: true,
          value: "cantidad",
          align: "center"
        }
      ],
      fields2Cap: [
        {
          text: "Resuelta",
          sortable: true,
          value: "resuelta",
          align: "center"
        },
        {
          text: "Código",
          sortable: true,
          value: "id",
          align: "center"
        },
        {
          text: "Descripción",
          sortable: true,
          value: "descripcion",
          align: "center"
        },
        {
          text: "Tipo",
          sortable: true,
          value: "tipo_incidencia.codigo",
          align: "center"
        }
      ],
      locale: {
        weekdays: [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado"
        ],
        months: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]
        },
        rangeSeparator: " a ",
        time_24hr: true
      },
      valid: true,
      rules: {
        required: value => !!value || "Campo requerido.",
        empty: value => value != "" || "Campo requerido.",
        nulled: value => value != null || "Campo requerido.",
        passLength: value =>
          (value.split("").length >= 8 && value.split("").length < 15) ||
          "La extensión de la contraseña deberá ser de entre 8 y 15 caracteres (ambos incluidos)",
        passCapitalLetter: value =>
          value.match(/.*[A-Z].*/) != null ||
          "La contraseña debe contener al menos una letra mayúscula",
        passLowCaseLetter: value =>
          value.match(/.*[a-z].*/) != null ||
          "La contraseña debe contener al menos una letra minúscula",
        passNumber: value =>
          value.match(/.*[0-9].*/) != null ||
          "La contraseña debe contener al menos un número",
        passSpecialCharacter: value =>
          "[`!@#$%^&*()_+-=[]{};':\"\\|,.<>/?~]"
            .split("")
            .some(sc => value.includes(sc)) ||
          "La contraseña debe contener al menos un caracter especial",
        isNumber: v =>
          (v != null &&
            !isNaN(
              v
                .toString()
                .replace(",", ".")
                .replace("±", "")
                .replace("&#177;", "")
                .replace("<", "")
                .replace(">", "")
                .replace("=", "")
                .replace("*", "")
                .replace("%", "")
                .replace("&#37", "")
            )) ||
          "Adjunte una expresión numérica",
        isNaN: v => isNaN(v) || "El campo no puede ser un número",
        validateEmail: value =>
          value.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) != null || "Email inválido"
      }
    };
  },
  methods: {
    async validar() {
      this.valid = await this.$refs.form.validate();
      if (this.valid) return true;
      else return false;
    },
    initModalCode() {
      if (this.modalCode == 2 || this.modalCode == 6) {
        this.getMC26();
      } else if (this.modalCode == 4) {
        this.getMC4();
      } else if (this.modalCode == 1) {
        this.getMC1();
      }
    },
    autoAssign() {
      this.info.usuario = this.$store.state.auth.user;
      this.info.id_user = this.$store.state.auth.user.id;
      var info = this.info;
      axios
        .put(
          this.$baseBackUrl + "api/pedidos/" + info.id,
          { id_user: info.id_user },
          apiConfig.connData()
          // eslint-disable-next-line
        )
        .then(response => {
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Asignación actualizada";
          // eslint-disable-next-line
        })
        .catch(e => {
          this.snackText = "Error al actualizar en la base de datos";
          this.snackColor = "error";
          this.snack = true;
        });
    },
    saveAssignment() {
      this.changeIdAsignacion();
      axios
        .put(
          this.$baseBackUrl + "api/pedidos/" + this.info.id,
          { id_user: this.info.id_user },
          apiConfig.connData()
          // eslint-disable-next-line
        )
        .then(response => {
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Asignación actualizada";
          // eslint-disable-next-line
        })
        .catch(e => {
          this.snackText = "Error al actualizar en la base de datos";
          this.snackColor = "error";
          this.snack = true;
        });
    },
    saveState(info) {
      axios
        .put(
          this.$baseBackUrl + "api/pedidos/" + info.id,
          { id_estado: info.id_estado, id_cliente: info.id_cliente, id_erp: info.id_erp },
          apiConfig.connData()
          // eslint-disable-next-line
        )
        .then(response => {
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Estado actualizado";
          // eslint-disable-next-line
        })
        .catch(e => {
          this.snackText = "Error al actualizar en la base de datos";
          this.snackColor = "error";
          this.snack = true;
        });
    },
    getMC26() {
      this.pickerIni = new Date();
      this.pickerEnd = new Date();
      if (this.info.id) {
        this.getDates();
      }
      this.getPrioridades();
      this.getUsers();
      this.getStates();
      this.getIncidenciasByOrder();
      this.getTareasByOrder();
    },
    getMC4() {
      this.tipoIncidencia = this.info.tipo_incidencia;
      this.getTipoIncs();
    },
    getMC1() {
      this.getRoles();
    },
    getActualRole() {
      return this.actualRol;
    },
    capitalizeFirst(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    lowerFirst(str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    },
    changeRol() {
      //HARDCODEADO
      this.info.roles = [];
      if (this.rol == "Taller") {
        this.info.roles.push(1);
      } else if (this.rol == "Oficina") {
        this.info.roles.push(1);
        this.info.roles.push(2);
      } else if (this.rol == "Admin") {
        this.info.roles.push(1);
        this.info.roles.push(2);
        this.info.roles.push(3);
      }
    },
    changeIdIncidencia() {
      this.info.id_tipo_incidencia = this.info.tipo_incidencia.id;
    },
    changeIdPrioridad() {
      this.info.id_prioridad = this.info.Prioridad.id;
    },
    changeIdAsignacion() {
      if (this.info.usuario != undefined || this.info.usuario != null) {
        this.info.id_user = this.info.usuario.id;
      } else {
        this.info.id_user = null;
      }
    },
    changeIdEstado() {
      this.info.id_estado = this.info.estado.id;
    },

    parseFecha(fecha) {
      var m = new Date();
      if (fecha == null) {
        return this.sliceDate(m);
      }
      m = new Date(fecha);
      return this.sliceDate(m);
    },
    sliceDate(m) {
      var hh = m.getHours();
      var mins = m.getMinutes();
      var secs = m.getSeconds();
      var hourtime = [
        (hh > 9 ? "" : "0") + hh,
        (mins > 9 ? "" : "0") + mins,
        (secs > 9 ? "" : "0") + secs
      ].join(":");
      var nf =
        ("0" + m.getUTCDate()).slice(-2) +
        "/" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "/" +
        m.getUTCFullYear() +
        " " +
        hourtime;
      return nf;
    },
    getPedidoId() {
      return this.info.id;
    },
    getDates() {
      this.pickerIni =
        this.info.fecha_pedido != null
          ? this.parseFecha(this.info.fecha_pedido)
          : this.parseFecha(new Date());

      this.pickerEnd =
        this.info.fecha_entrega != null
          ? this.parseFecha(this.info.fecha_entrega)
          : this.parseFecha(new Date());
    },
    getPrioridades() {
      axios
        .get(this.$baseBackUrl + "api/prioridades", apiConfig.connData())
        .then(response => {
          var res = response.data;
          this.prioridades = res;
        })
        // eslint-disable-next-line
        .catch(e => {
          console.log(e);
        });
    },
    getRoles() {
      axios
        .get(this.$baseBackUrl + "api/roles", apiConfig.connData())
        .then(response => {
          var res = response.data;
          res.forEach(element => {
            this.roles.push({ name: this.capitalizeFirst(element.name) });
          });
          this.rol = this.info.roles[this.info.roles.length - 1];
          this.rol = this.capitalizeFirst(this.rol);
        })
        .catch(e => {
          console.log(e);
        });
      this.rol = null;
    },
    getTipoIncs() {
      axios
        .get(this.$baseBackUrl + "api/tipoIncidencia", apiConfig.connData())
        .then(response => {
          var res = response.data;
          this.tipoIncs = res;
        })
        .catch(e => {
          console.log(e);
        });
    },
    async getUsers() {
      await axios
        .get(this.$baseBackUrl + "api/usuarios", apiConfig.connData())
        .then(response => {
          var res = response.data;
          this.users = res;
          // if(this.info.usuario == null){
          //   this.info.id_user = null
          // }
          // console.log(this.info)
        })
        .catch(e => {
          console.log(e);
        });
    },
    getStates() {
      axios
        .get(this.$baseBackUrl + "api/estados", apiConfig.connData())
        .then(response => {
          var res = response.data;
          this.states = res;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getTareasByOrder() {
      var id_pedido = this.info.id;
      return this.$baseBackUrl + "api/tareas/orden/" + id_pedido;
    },
    getIncidenciasByOrder() {
      var id_pedido = this.info.id;
      return this.$baseBackUrl + "api/incidencias/orden/" + id_pedido;
    },
    setPickerDate(pickerIni, pickerEnd) {
      this.setPickerDateInit(pickerIni);
      this.setPickerDateEnd(pickerEnd);
    },
    setPickerDateInit(value) {
      this.info.fecha_pedido = this.toDBFecha(value);
    },
    setPickerDateEnd(value) {
      this.info.fecha_entrega = this.toDBFecha(value);
    },
    toDBFecha(value) {
      var dia = value.substr(0, 2);
      var mes = value.substr(3, 2);
      var year = value.substr(6, 4);
      var half = year + "-" + mes + "-" + dia + "T";
      var hour = value.substr(11, 2);
      var min = value.substr(14, 2);
      var sec = value.substr(17, 2);
      var half2 = hour + ":" + min + ":" + sec + ".000Z";
      var final = half + half2;
      return final;
    }
  }
};
</script>
<style scoped>
h5 {
  color: #004283;
}
.tableFlex {
  width: 50%;
}
.v-card {
  padding: 1em;
  margin-bottom: 0.8em;
}

#areas {
  margin-top: 0.35em;
  margin-bottom: 0.85em;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/old/OptionalModalsOld.vue